import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { FeaturedTransporters } from "../components/FeaturedTransporters";
import { useAuth, dashboardPath } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { JobsBoard } from "../components/JobsBoard";
import { PostJobDialog } from "../components/PostJobDialog";
import { IMAGES, VEHICLE_TYPES } from "../lib/constants";
import { ArrowRight } from "lucide-react";

export default function Transport() {
  const { user } = useAuth();
  const isPoster = user && (user.role === "seller" || user.role === "company");
  const approvedPoster = isPoster && user.status === "approved";

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="border-b border-foreground bg-foreground text-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2">
          <div className="px-4 sm:px-8 py-12 lg:py-16 flex flex-col justify-center">
            <span className="label-caps text-accent mb-4">Transport Exchange</span>
            <h1 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-none">
              Need a Sprinter, van, truck, or transporter?
            </h1>
            <p className="text-white/70 mt-5 max-w-lg text-base">
              Post your job and receive quotes from verified drivers. From a single box to a 40t
              container — small jobs and big jobs, local and long-distance.
            </p>
            <div className="flex flex-wrap gap-3 mt-7">
              {approvedPoster ? (
                <PostJobDialog className="rounded-none bg-accent text-foreground hover:bg-accent/90 h-12 px-6 text-base" onSaved={() => window.location.reload()} />
              ) : (
                <Link to={isPoster ? dashboardPath(user.role) : "/register"} data-testid="transport-post-cta">
                  <Button className="rounded-none bg-accent text-foreground hover:bg-accent/90 h-12 px-6 text-base">Post a Transport Job <ArrowRight className="ml-2 h-4 w-4" /></Button>
                </Link>
              )}
              <Link to={user && user.role === "driver" ? "/driver" : "/register"} data-testid="transport-register-driver-btn">
                <Button variant="outline" className="rounded-none h-auto min-h-12 py-2 px-5 text-sm sm:text-base border-white text-white hover:bg-white hover:text-foreground whitespace-normal leading-tight text-center">
                  Register as Transporter / Sprinter Driver
                </Button>
              </Link>
            </div>
            <div className="flex flex-wrap gap-2 mt-7">
              {VEHICLE_TYPES.map((v) => <span key={v} className="border border-white/30 px-3 py-1 text-xs font-medium">{v}</span>)}
            </div>
          </div>
          <div className="min-h-[240px]">
            <img src={IMAGES.fleet} alt="Transport fleet" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      {/* Board */}
      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-10">
        <div className="flex items-center justify-between gap-3 flex-wrap mb-6">
          <div>
            <span className="label-caps text-primary">Available transport jobs</span>
            <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight">Browse open jobs & apply</h2>
          </div>
          {approvedPoster && <PostJobDialog onSaved={() => window.location.reload()} />}
        </div>
        <JobsBoard />
      </section>
      <FeaturedTransporters limit={8} dark />
      <Footer />
    </div>
  );
}
